// extracted by mini-css-extract-plugin
export default {"wrapper":"IntervalSelect_wrapper__O5+ip","segmented":"IntervalSelect_segmented__5a4YF","segmentedItem":"IntervalSelect_segmentedItem__Q09xI"};